import * as Yup from "yup";

export const QrValidation = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Please enter a valid email address")
    .required("Email is required"),
  password: Yup.string()
    .trim()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),
});

export const TwoFACodeValidation = Yup.object().shape({
  twoFACode: Yup.string()
    .trim()
    .matches(/^[0-9]{6}$/, "Enter a valid 6-digit code")
    .required("2FA code is required"),
});